import { DataService } from './lib/data';

export const BASE_PATH = '/access/crn';

export const DATA_SERVICE$ = DataService.fromApi(`${BASE_PATH}/api/v1.0`);

